import React from "react";
import { SunIcon, SunriseIcon, SunsetIcon, BoxIcon } from "lucide-react";
import { timetables } from "../../data/schedule";
import { MockupTag } from "./MockupTag";
const icons: BoxIcon[] = [SunriseIcon, SunIcon, SunsetIcon];

// Timetable options shown as cards with a simple day bar that marks when each class runs.
export function TimetableTable() {
  return <div data-id="element-895" data-mp="2mcmzmr80zgxt">
      <MockupTag note="Sample class times" className="mb-4" data-id="element-896" data-mp="3064fa0xlc9ik" />
      <ul className="grid gap-5 md:grid-cols-3" data-id="element-897" data-mp="304jmafqxcymt">
        {timetables.map((row, index) => {
        const Icon = icons[index % icons.length];
        return <li key={row.name} className="flex flex-col rounded-[24px] border border-line bg-white p-6" data-id="element-898" data-mp="3a40najv8eocg" data-mpi={index}>
              <div className="flex items-center justify-between" data-id="element-899" data-mp="354o3k7znpxe3">
                <span className="flex h-11 w-11 items-center justify-center rounded-[13px] bg-cream text-brand" aria-hidden="true" data-id="element-900" data-mp="3534pmo1h3yfh">
                  <Icon className="h-5 w-5" data-id="element-901" data-mp="1arputstlv8sv" />
                </span>
                <span className="type-h5 text-ink" data-id="element-902" data-mp="1atj31cjva12z">{row.time}</span>
              </div>
              <h3 className="mt-6 type-card-title text-ink" data-id="element-903" data-mp="g8ueavgcla1s">{row.name}</h3>
              <p className="mt-2 type-card-desc" data-id="element-904" data-mp="kdby2umpjnck">{row.note}</p>
              <div className="mt-auto pt-6" aria-hidden="true" data-id="element-905" data-mp="pb3o1j3skze4">
                <div className="flex gap-1" data-id="element-906" data-mp="p9itvule3igs">
                  {Array.from({
                length: 12
              }).map((_, tick) => {
                const active = Math.floor(tick / 4) === index;
                return <span key={tick} className={`h-2 flex-1 rounded-[3px] ${active ? 'bg-brand' : 'bg-line'}`} data-id="element-907" data-mp="z3rhc3vkcl83" data-mpi={tick} />;
              })}
                </div>
                <div className="mt-2 flex justify-between type-fine text-muted" data-id="element-908" data-mp="18365uxs66lpy">
                  <span data-id="element-909" data-mp="1d1g5bkkxg8hd">Morning</span>
                  <span data-id="element-910" data-mp="1d0et3cs6dfy2">Evening</span>
                </div>
              </div>
            </li>;
      })}
      </ul>
    </div>;
}